<template>
  <transition
    mode="out-in"
    enter-active-class="animated fadeIn fast"
    leave-active-class="animated fadeOut fast"
    >
    <slot />
  </transition>
</template>


<script>
/* @flow */
export default {
  name: 'RouteTransition',
}
</script>



// WEBPACK FOOTER //
// src/components/RouteTransition.vue